import Component, { mixins } from 'vue-class-component'

import WithRender from './LocationSvg.html'

@WithRender
@Component
export default class LocationSvg extends mixins() {}
